module.exports = __webpack_public_path__ + "static/media/casual-exercise-healthy-life-jogging-svgrepo-com.037d9f8c.svg";